import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { theme } from '../../../../theme';

const { colors, shadows, breakpoints, filters } = theme;

export const ButtonFilter = styled(Button)`
  box-shadow: none !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    box-shadow: none !important;
  }
`;

export const DivFilterBox = styled.div`
  position: fixed;
  right: -350px;
  top: 0;
  z-index: 1015;
  left: auto;
  bottom: 0;
  max-height: 100%;
  box-shadow: ${shadows.box};
  width: 300px;
  padding: 20px 0 20px 20px;
  background: ${colors.white};
  color: ${colors.textPrimary};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.2s ease-in-out;

  &.filter-open {
    right: 0;
  }

  &.filter-pageLayout {
    top: 100px;

    ${theme.up(breakpoints.lg)} {
      top: 65px;
    }
  }

  &.filter-modal {
    position: absolute;
    overflow: auto;
    overflow-x: hidden;
  }
`;

export const ButtonClose = styled(ButtonFilter)`
  &.filter-btn-close {
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 0;
    height: 36px;
    width: 36px;
    border-radius: 0;
    border: none;
    background-color: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover,
    &:active,
    &:focus {
      color: #fff;
      background-color: ${filters.mediumBlue}!important;
    }
  }
`;

export const H3Title = styled.h3`
  &.filter-title {
    font-size: 1.3rem;
    font-weight: 600;
    padding: 27px 20px 18px;
    box-shadow: ${shadows.box};
    margin: -20px -20px 20px;
  }
`;

export const DivContent = styled.div`
  position: relative;
  overflow-y: auto;
  flex-grow: 1 !important;
`;

export const DivFooter = styled.div`
  margin-right: 20px;
  padding-top: 18px;
  display: flex;
  justify-content: space-between;

  & > button:last-of-type {
    width: 100px;
  }
`;
